import { showSpinner, hideSpinner } from '../helpers/spinner'

document.addEventListener('DOMContentLoaded', () => {
  const videoActivators = document.querySelectorAll('[data-activate-video]')

  videoActivators.forEach(activator => {
    activator.addEventListener('click', event => {
      const target = event.target as HTMLElement
      if (target.classList.contains('player')) {
        target.style.display = 'none'
        const iframe = target.querySelector('iframe')
        if (iframe) {
          iframe.setAttribute('src', '')
        }
      } else {
        const isAvailable = activator.getAttribute('data-available') === 'True'
        if (!isAvailable) return

        const videoId = activator.getAttribute('data-video-id')
        const player = document.querySelector(`.player[data-video-id="${videoId}"]`)
        if (player) {
          showSpinner(player as HTMLElement)
          ;(player as HTMLElement).style.display = 'block'
          const iframe = player.querySelector('iframe')
          if (iframe) {
            const src = iframe.getAttribute('data-src')
            iframe.setAttribute('src', `${src}?autoplay=1`)
            iframe.onload = () => hideSpinner(player as HTMLElement)
          } else {
            hideSpinner(player as HTMLElement)
          }
        }
      }
    })
  })

  const players = document.querySelectorAll('.player')
  players.forEach(player => {
    player.addEventListener('click', () => {
      ;(player as HTMLElement).style.display = 'none'
      const iframe = player.querySelector('iframe')
      if (iframe) {
        iframe.setAttribute('src', '')
      }
    })
  })
})
